/* Custom cart drawer — vanilla JS. Uses Shopify AJAX Cart API only.
   GET /cart.js  POST /cart/add.js  POST /cart/change.js
   Money formatted from cents in the cart's presentment currency. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('CartDrawerConfig');
  if (!cfgEl) return;
  var CFG = {}; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { CFG = {}; }
  var drawer = document.getElementById('CartDrawer');
  var overlay = document.getElementById('CartDrawerOverlay');
  if (!drawer || !overlay) return;

  var els = {
    items: drawer.querySelector('[data-cd-items]'),
    empty: drawer.querySelector('[data-cd-empty]'),
    count: drawer.querySelectorAll('[data-cd-count]'),
    footer: drawer.querySelector('[data-cd-footer]'),
    subtotal: drawer.querySelector('[data-cd-subtotal]'),
    shipping: drawer.querySelector('[data-cd-shipping]'),
    discountRow: drawer.querySelector('[data-cd-discount-row]'),
    discountLabel: drawer.querySelector('[data-cd-discount-label]'),
    discountValue: drawer.querySelector('[data-cd-discount-value]'),
    shipNote: drawer.querySelector('[data-cd-shipnote]'),
    taxNote: drawer.querySelector('[data-cd-taxnote]'),
    bundleDeal: drawer.querySelector('[data-cd-bundle-deal]'),
    totalRow: drawer.querySelector('[data-cd-total-row]'),
    totalLabel: drawer.querySelector('[data-cd-total-label]'),
    total: drawer.querySelector('[data-cd-total]'),
    payment: drawer.querySelector('[data-cd-payment]'),
    badge: drawer.querySelector('[data-cd-badge]'),
    checkout: drawer.querySelector('[data-cd-checkout]'),
    bundle: drawer.querySelector('[data-cd-bundle]'),
    bundleMsg: drawer.querySelector('[data-cd-bundle-msg]'),
    unlockedLabel: drawer.querySelector('[data-cd-unlocked-label]'),
    progressFill: drawer.querySelector('[data-cd-progress-fill]'),
    nodes: drawer.querySelectorAll('[data-cd-node]'),
    gift: drawer.querySelector('[data-cd-gift]'),
    giftInner: drawer.querySelector('[data-cd-gift-inner]'),
    upsellCards: drawer.querySelectorAll('[data-cd-upsell-card]'),
    discountForm: drawer.querySelector('[data-cd-discount-form]'),
    discountInput: drawer.querySelector('[data-cd-discount-input]'),
    discountApply: drawer.querySelector('[data-cd-discount-apply]'),
    discountPills: drawer.querySelector('[data-cd-discount-pills]'),
    discountErrorEl: drawer.querySelector('[data-cd-discount-error]')
  };

  var locale = document.documentElement.lang || 'en';
  var lastCart = null;
  var giftBusy = false;
  var selfDispatch = false;

  /* qualifying set for the bundle */
  var QSET = {};
  (CFG.bundleProductIds || []).concat(CFG.bundleCollectionIds || []).forEach(function (id) { QSET[String(id)] = true; });
  var HAS_QSET = Object.keys(QSET).length > 0;
  function isQualifying(item) { return !HAS_QSET || QSET[String(item.product_id)]; }
  function isGift(item) {
    var p = item.properties || {};
    return p._gift === 'true' || p._gift === true || (CFG.giftProductId && String(item.product_id) === String(CFG.giftProductId));
  }
  function notGift(item) { return !isGift(item); }
  function findGiftLine(cart) { return cart.items.filter(isGift)[0] || null; }

  function money(cents, currency) {
    var d = (typeof CFG.moneyDecimals === 'number') ? CFG.moneyDecimals : 2;
    var amount = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency || 'USD', minimumFractionDigits: d, maximumFractionDigits: d }).format(amount);
    } catch (e) { return amount.toFixed(d) + ' ' + (currency || ''); }
  }
  function fill(tpl, map) {
    var out = String(tpl || '');
    for (var k in map) { if (map.hasOwnProperty(k)) { var v = (map[k] == null) ? '' : map[k]; out = out.split('{' + k + '}').join(v); } }
    return out;
  }
  function escapeHtml(s) { return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
  /* Market-aware URLs. Under a subfolder market (e.g. /en-gb/) Shopify needs Ajax
     requests sent through Shopify.routes.root, otherwise the cart is read and
     written in the PRIMARY (AU) market context. On the main domain root is "/"
     so nothing changes there. */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function route(p) { return ROOT + String(p).replace(/^\//, ''); }
  function postJSON(url, data) { return fetch(route(url), { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(data) }).then(function(r){return r.json();}); }
  function getCart() { return fetch(route('/cart.js'), { headers:{'Accept':'application/json'} }).then(function(r){return r.json();}); }

  /* open / close */
  var bootedOnce = false;
  function endBoot(minMs, started) {
    var wait = Math.max(0, (minMs||0) - (Date.now() - started));
    window.setTimeout(function(){ drawer.classList.remove('is-booting'); }, wait);
  }
  function openDrawer() {
    document.body.classList.add('cd-open');
    overlay.hidden = false; void overlay.offsetWidth;
    overlay.classList.add('is-open'); drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    /* show the logo loader on the first open per page load, and whenever an
       add-in-flight already set .is-booting; hold it a beat so it reads */
    var boot = !bootedOnce || drawer.classList.contains('is-booting');
    var started = Date.now();
    if (!bootedOnce) drawer.classList.add('is-booting');
    bootedOnce = true;
    var p = refresh(true);
    if (boot) Promise.resolve(p).then(function(){ endBoot(800, started); }, function(){ endBoot(800, started); });
  }
  function closeDrawer() {
    overlay.classList.remove('is-open'); drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true'); document.body.classList.remove('cd-open');
    window.setTimeout(function(){ overlay.hidden = true; }, 350);
  }

  /* gift qualification + auto sync (excludes the gift itself) */
  function giftQualifies(cart) {
    var g = findGiftLine(cart);
    if (CFG.giftThresholdType === 'total') {
      var t = cart.total_price - (g ? g.final_line_price : 0);
      return t >= (CFG.giftThresholdCents || 0);
    }
    var c;
    if (HAS_QSET) {
      /* count only qualifying (e.g. hoodie) units so the drawer matches the
         backing Buy-X-Get-Y discount, which requires a qualifying product */
      c = 0;
      cart.items.forEach(function(i){ if (notGift(i) && isQualifying(i)) c += i.quantity; });
    } else {
      c = cart.item_count - (g ? g.quantity : 0);
    }
    return c >= (CFG.giftThresholdCount || 0);
  }
  function maybeSyncGift(cart) {
    if (!CFG.giftShow || !CFG.giftVariantId || giftBusy) return Promise.resolve(cart);
    var g = findGiftLine(cart), ok = giftQualifies(cart);
    if (CFG.giftMode === 'auto' && ok && !g) {
      giftBusy = true;
      return postJSON('/cart/add.js', { items:[{ id:CFG.giftVariantId, quantity:1, properties:{ _gift:'true' } }] })
        .then(getCart).then(function(c){ giftBusy=false; return c; }).catch(function(){ giftBusy=false; return cart; });
    }
    if (!ok && g) { /* auto-remove in BOTH modes when dropping below threshold */
      giftBusy = true;
      return postJSON('/cart/change.js', { id:g.key, quantity:0 })
        .then(function(c){ giftBusy=false; return c; }).catch(function(){ giftBusy=false; return cart; });
    }
    return Promise.resolve(cart);
  }

  /* bundle computation */
  /* Price of ONE bundle set, in the shopper's CURRENT presentment currency.
     Preferred source is the live cart (already market-priced); falls back to
     the Liquid-rendered reference unit price for an empty cart. Mirrors a
     native "Buy X Get Y, N% off" discount, so it stays correct in AU/NZ/UK
     without any hard-coded FX rate. */
  function bundleSetUnit(origUnits) {
    var n = CFG.bundleQuantity || 2;
    var unit = 0;
    if (origUnits && origUnits.length) {
      var s = origUnits.slice().sort(function(a,b){ return b-a; });
      var take = Math.min(n, s.length), sum = 0;
      for (var i=0;i<take;i++) sum += s[i];
      unit = Math.round(sum / take);
    }
    return unit || CFG.bundleRefUnitCents || 0;
  }
  /* Shopify TRUNCATES the percentage discount to whole cents (verified live in
     AUD/GBP/NZD), so floor - not round - to match checkout exactly. The epsilon
     guards against binary float error on exact values (e.g. 40% of 10000). */
  function bundleSetSaving(origUnits) {
    var n = CFG.bundleQuantity || 2, pct = Number(CFG.bundleSetPercent) || 0, unit = bundleSetUnit(origUnits);
    if (unit > 0 && pct > 0) return Math.floor((unit * pct / 100) + 1e-6);
    return Math.max(0, unit * n - (CFG.bundlePriceCents || 0));
  }
  function bundleSetPrice(origUnits) {
    var n = CFG.bundleQuantity || 2, pct = Number(CFG.bundleSetPercent) || 0, unit = bundleSetUnit(origUnits);
    if (unit > 0 && pct > 0) return Math.max(0, (unit * n) - Math.floor((unit * pct / 100) + 1e-6));
    return CFG.bundlePriceCents || 0;
  }

  function computeBundle(cart) {
    var out = { show:!!CFG.bundleShow, unlocked:false, qty:0, need:CFG.bundleQuantity||3, discount:0, remaining:CFG.bundleQuantity||3, subtotalQualifying:0, priceCents:0, savingCents:0 };
    if (!CFG.bundleShow) { out.priceCents = bundleSetPrice(null); out.savingCents = bundleSetSaving(null); return out; }
    var q = cart.items.filter(function(i){ return notGift(i) && isQualifying(i); });
    var units = [], origUnits = [], subtotal = 0;
    q.forEach(function(i){
      subtotal += i.final_line_price;
      var u = i.quantity ? i.final_line_price/i.quantity : i.final_price;
      var ou = i.quantity ? i.original_line_price/i.quantity : (i.original_price || i.final_price);
      for (var n=0;n<i.quantity;n++) { units.push(u); origUnits.push(ou); }
    });
    out.qty = units.length; out.subtotalQualifying = subtotal;
    out.remaining = Math.max(0, out.need - out.qty);
    out.unlocked = out.need > 0 && out.qty >= out.need;
    out.priceCents = bundleSetPrice(origUnits);
    out.savingCents = bundleSetSaving(origUnits);
    if (out.unlocked) {
      if (CFG.bundleType === 'price') {
        var sets = Math.floor(out.qty / out.need); units.sort(function(a,b){return b-a;});
        var covered = 0, k = sets*out.need; for (var j=0;j<k;j++) covered += units[j];
        out.discount = Math.max(0, covered - sets*(out.priceCents||0));
      } else if (CFG.bundleType === 'amount') {
        /* flat $ off, applied once (matches a native Amount-off-order discount) */
        out.discount = Math.min(subtotal, CFG.bundleAmountCents || 0);
      } else {
        out.discount = Math.round(subtotal * (CFG.bundlePercent||0) / 100);
      }
    }
    return out;
  }

  /* render */
  function render(cart) {
    lastCart = cart;
    var currency = cart.currency, count = cart.item_count;
    els.count.forEach(function(el){ el.textContent = '(' + count + ')'; });
    updateSiteCart(cart);

    var isEmpty = count === 0;
    els.empty.hidden = !isEmpty; els.items.hidden = isEmpty;
    if (els.footer) els.footer.style.display = isEmpty ? 'none' : '';

    els.items.innerHTML = cart.items.map(function(i){ return itemHTML(currency, i); }).join('');
    hydrateVariantSelects();

    var bundle = computeBundle(cart);
    renderBundle(cart, bundle);
    renderGift(cart);
    renderTotals(cart, bundle);
    renderUpsells(cart);
    renderCodePills(cart);
  }

  /* discount codes (POST /cart/update.js { discount: "A,B" }) */
  function appliedCodes(cart) {
    return ((cart && cart.discount_codes) || []).filter(function(d){ return d.applicable; }).map(function(d){ return d.code; });
  }
  function setDiscounts(codes) { return postJSON('/cart/update.js', { discount: codes.join(',') }); }
  function renderCodePills(cart) {
    if (!els.discountPills) return;
    var codes = appliedCodes(cart);
    els.discountPills.hidden = codes.length === 0;
    els.discountPills.innerHTML = codes.map(function(c){
      return '<li class="cd-discount__pill"><span>'+escapeHtml(c)+'</span>'+
        '<button type="button" data-cd-remove-code data-code="'+escapeHtml(c)+'" aria-label="Remove discount code '+escapeHtml(c)+'">&times;</button></li>';
    }).join('');
  }
  function applyCode() {
    if (!els.discountInput) return;
    var code = els.discountInput.value.trim();
    if (!code) return;
    var done = function(){ if (els.discountApply) els.discountApply.classList.remove('is-loading'); };
    if (els.discountApply) els.discountApply.classList.add('is-loading');
    if (els.discountErrorEl) els.discountErrorEl.hidden = true;
    var prev = appliedCodes(lastCart);
    if (prev.map(function(c){return c.toLowerCase();}).indexOf(code.toLowerCase()) !== -1) { els.discountInput.value=''; done(); return; }
    setDiscounts(prev.concat([code])).then(function(cart){
      var entry = ((cart && cart.discount_codes) || []).filter(function(d){ return d.code.toLowerCase() === code.toLowerCase(); })[0];
      if (!entry || !entry.applicable) {
        if (els.discountErrorEl) els.discountErrorEl.hidden = false;
        /* strip the rejected code again so it doesn't linger on the cart */
        return setDiscounts(prev).then(function(c2){ render(c2); done(); });
      }
      els.discountInput.value = '';
      /* success: collapse the field again, pills show the applied code */
      if (els.discountForm) els.discountForm.hidden = true;
      var tg = drawer.querySelector('[data-cd-discount-toggle]');
      if (tg) { tg.setAttribute('aria-expanded','false'); tg.classList.remove('is-open'); }
      render(cart); done();
    }).catch(function(){ if (els.discountErrorEl) els.discountErrorEl.hidden = false; done(); });
  }
  function removeCode(code) {
    var codes = appliedCodes(lastCart).filter(function(c){ return c.toLowerCase() !== String(code).toLowerCase(); });
    setDiscounts(codes).then(function(cart){ render(cart); }).catch(function(){ refresh(true); });
  }

  function giftVariantSelectHTML(currentId, attr) {
    var vs = CFG.giftVariants || [];
    if (vs.length < 2) return '';
    var opts = vs.map(function(v){
      return '<option value="'+v.id+'"'+(String(v.id)===String(currentId)?' selected':'')+(v.available?'':' disabled')+'>'+escapeHtml(v.title)+(v.available?'':' — Sold out')+'</option>';
    }).join('');
    return '<select class="cd-card__size cd-gift__variant" '+attr+' aria-label="Choose your gift option">'+opts+'</select>';
  }

  /* subtle custom variant dropdown (trigger text + styled menu) */
  function vselHTML(currentId, options, kindAttr, ariaLabel) {
    if (!options || options.length < 2) return '';
    var cur = options.filter(function(o){ return String(o.id) === String(currentId); })[0];
    var opts = options.map(function(o){
      var sel = String(o.id) === String(currentId);
      return '<button type="button" class="cd-vsel__opt'+(sel?' is-selected':'')+'"'+(o.available?'':' disabled')+' data-value="'+o.id+'" role="option" aria-selected="'+sel+'">'+
        '<span>'+escapeHtml(o.title)+'</span>'+(o.available?'':'<span class="cd-vsel__so">Sold out</span>')+'</button>';
    }).join('');
    return '<div class="cd-vsel" '+kindAttr+'>'+
      '<button type="button" class="cd-vsel__btn" data-cd-vsel-btn aria-haspopup="listbox" aria-expanded="false" aria-label="'+escapeHtml(ariaLabel||'Change option')+'">'+
        '<span class="cd-vsel__label">'+escapeHtml(cur ? cur.title : '')+'</span>'+
        '<svg class="cd-vsel__caret" viewBox="0 0 10 6" width="9" height="6" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.2" fill="none"/></svg>'+
      '</button>'+
      '<div class="cd-vsel__menu" role="listbox" hidden>'+opts+'</div>'+
    '</div>';
  }
  function closeVsels() {
    drawer.querySelectorAll('.cd-vsel__menu:not([hidden])').forEach(function(m){
      m.hidden = true;
      m.parentElement.classList.remove('is-up');
      var b = m.parentElement.querySelector('[data-cd-vsel-btn]');
      if (b) b.setAttribute('aria-expanded','false');
    });
  }
  function toggleVsel(btn) {
    var wrap = btn.closest('.cd-vsel');
    var menu = wrap && wrap.querySelector('.cd-vsel__menu');
    if (!menu) return;
    var willOpen = menu.hidden;
    closeVsels();
    if (!willOpen) return;
    menu.hidden = false;
    btn.setAttribute('aria-expanded','true');
    var r = menu.getBoundingClientRect();
    if (r.bottom > window.innerHeight - 24) wrap.classList.add('is-up');
  }

  function itemHTML(currency, item) {
    var gift = isGift(item);
    var imgSrc = item.image ? (item.image.indexOf('?')===-1 ? item.image+'?width=160' : item.image+'&width=160') : '';
    var img = item.image ? '<img src="'+imgSrc+'" alt="'+escapeHtml(item.product_title)+'" loading="lazy">' : '';
    var variant = (item.variant_title && item.variant_title!=='Default Title') ? '<p class="cd-item__variant">'+escapeHtml(item.variant_title)+'</p>' : '';

    var priceHTML, controls, aside;
    if (gift) {
      if (CFG.giftPriceDisplay === 'struck') {
        /* a $0 gift product carries its real value in compare-at */
        var struckCents = item.original_line_price || (CFG.giftCompareCents || 0) * item.quantity;
        priceHTML = (struckCents > 0 ? '<s>'+money(struckCents,currency)+'</s> ' : '') + '<span class="cd-item__price--free">Free</span>';
      } else {
        priceHTML = '<span class="cd-item__price--free">Free</span>';
      }
      var giftSel = vselHTML(item.variant_id, CFG.giftVariants || [], 'data-cd-vsel-gift', 'Choose your gift colour');
      controls = '<span class="cd-gift-badge">'+escapeHtml(CFG.giftLineLabel||'GIFT')+'</span>' + giftSel;
      var remove = (CFG.giftMode==='claim') ? '<button type="button" class="cd-remove" data-cd-remove>Remove</button>' : '';
      aside = '<span class="cd-item__price">'+priceHTML+'</span>'+remove;
      /* gift line is not linked to the product page; the select replaces the variant text */
      return '<div class="cd-item cd-item--gift" data-key="'+item.key+'">'+
        '<span class="cd-item__media">'+img+'</span>'+
        '<div class="cd-item__info">'+
          '<h3 class="cd-item__title">'+escapeHtml(item.product_title)+'</h3>'+
          (giftSel ? '' : variant) + controls +
        '</div>'+
        '<div class="cd-item__aside">'+aside+'</div></div>';
    } else {
      var hasCompare = item.original_line_price > item.final_line_price;
      priceHTML = hasCompare ? '<s>'+money(item.original_line_price,currency)+'</s>'+money(item.final_line_price,currency) : money(item.final_line_price,currency);
      controls = '<div class="cd-qty">'+
        '<button type="button" class="cd-qty__btn" data-cd-minus aria-label="Decrease quantity">&minus;</button>'+
        '<span class="cd-qty__value">'+item.quantity+'</span>'+
        '<button type="button" class="cd-qty__btn" data-cd-plus aria-label="Increase quantity">+</button></div>';
      aside = '<span class="cd-item__price">'+priceHTML+'</span><button type="button" class="cd-remove" data-cd-remove>Remove</button>';
    }
    /* the variant slot is upgraded to a size <select> once the product's
       variant list has been fetched (see hydrateVariantSelects) */
    var variantSlot = '<div class="cd-item__variantwrap" data-cd-variant-slot data-handle="'+escapeHtml(item.handle||'')+'" data-vid="'+item.variant_id+'">'+variant+'</div>';
    return '<div class="cd-item" data-key="'+item.key+'">'+
      '<a class="cd-item__media" href="'+item.url+'" tabindex="-1">'+img+'</a>'+
      '<div class="cd-item__info">'+
        '<h3 class="cd-item__title"><a href="'+item.url+'">'+escapeHtml(item.product_title)+'</a></h3>'+
        variantSlot + controls +
      '</div>'+
      '<div class="cd-item__aside">'+aside+'</div></div>';
  }

  /* size/variant switching on cart lines */
  var PRODUCT_CACHE = {};
  function fetchProduct(handle) {
    if (PRODUCT_CACHE[handle]) return Promise.resolve(PRODUCT_CACHE[handle]);
    return fetch(route('/products/'+handle+'.js'), { headers:{'Accept':'application/json'} })
      .then(function(r){ if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function(p){ PRODUCT_CACHE[handle] = p; return p; });
  }
  function hydrateVariantSelects() {
    els.items.querySelectorAll('[data-cd-variant-slot]').forEach(function(slot){
      var handle = slot.getAttribute('data-handle');
      if (!handle) return;
      fetchProduct(handle).then(function(p){
        if (!p || !p.variants || p.variants.length < 2) return;
        if (!slot.isConnected) return;
        var cur = slot.getAttribute('data-vid');
        var options = p.variants.map(function(v){ return { id: v.id, title: v.title, available: v.available }; });
        slot.innerHTML = vselHTML(cur, options, 'data-cd-vsel-line', 'Change size');
      }).catch(function(){});
    });
  }
  function swapLine(item, newVid) {
    if (!item || String(item.variant_id) === String(newVid)) return;
    drawer.classList.add('is-loading');
    var target = 0;
    ((lastCart && lastCart.items) || []).forEach(function(i){ if (String(i.variant_id) === String(newVid)) target += i.quantity; });
    var updates = {}; updates[item.variant_id] = 0; updates[newVid] = target + item.quantity;
    postJSON('/cart/update.js', { updates: updates })
      .then(maybeSyncGift)
      .then(function(cart){ render(cart); drawer.classList.remove('is-loading'); })
      .catch(function(){ drawer.classList.remove('is-loading'); refresh(true); });
  }

  function renderBundle(cart, b) {
    if (!els.bundle) return;
    var pct = CFG.bundlePercent || 0, price = money(b.priceCents || CFG.bundlePriceCents, cart.currency);
    var tokens = { remaining:b.remaining, quantity:b.need, percent:pct, price:price, amount:money(CFG.bundleAmountCents, cart.currency), saving:money(b.savingCents || 0, cart.currency) };
    /* always-visible highlight until the bundle is unlocked, e.g. "Save £40.00" */
    if (els.bundleDeal) {
      var dealTxt = (!b.unlocked && CFG.bundleDealLabel && b.savingCents > 0) ? fill(CFG.bundleDealLabel, tokens) : '';
      els.bundleDeal.textContent = dealTxt;
      els.bundleDeal.hidden = !dealTxt;
    }
    if (b.unlocked) {
      els.bundleMsg.textContent = fill(CFG.bundleUnlockedMessage, tokens);
      if (els.unlockedLabel) { els.unlockedLabel.hidden = false; els.unlockedLabel.textContent = '✓ ' + fill(CFG.bundleUnlockedLabel, tokens); }
    } else {
      var piece = (b.remaining === 1 ? CFG.pieceSingular : CFG.piecePlural) || '';
      tokens.piece = piece.toLowerCase();
      els.bundleMsg.textContent = fill(CFG.bundleMessage, tokens);
      if (els.unlockedLabel) els.unlockedLabel.hidden = true;
    }
    els.nodes.forEach(function(node){ var idx = parseInt(node.getAttribute('data-cd-node'),10); node.classList.toggle('is-complete', b.qty >= idx); });
    var pos = Math.max(0, Math.min(b.qty, b.need) - 1) / Math.max(1, b.need - 1);
    if (els.progressFill) els.progressFill.style.width = (pos*100) + '%';
  }

  function renderGift(cart) {
    if (!els.gift) return;
    if (!CFG.giftShow || !CFG.giftVariantId) { els.gift.hidden = true; return; }
    var g = findGiftLine(cart), ok = giftQualifies(cart);
    // gift already in cart -> it shows as a line item; hide the promo box
    if (g) { els.gift.hidden = true; return; }
    els.gift.hidden = false;
    if (ok && CFG.giftMode === 'claim') {
      els.giftInner.innerHTML = '<p class="cd-gift__msg">'+escapeHtml(CFG.giftUnlockedMessage)+'</p>'+
        giftVariantSelectHTML(CFG.giftVariantId, 'data-cd-claim-variant') +
        '<button type="button" class="cd-gift__claim" data-cd-claim-gift>'+escapeHtml(CFG.giftClaimText||'Add my free gift')+'</button>';
    } else if (ok && CFG.giftMode === 'auto') {
      // auto mode will add it on sync; show a brief unlocked note meanwhile
      els.giftInner.innerHTML = '<p class="cd-gift__msg">'+escapeHtml(CFG.giftUnlockedMessage)+'</p>';
    } else {
      var remaining;
      if (CFG.giftThresholdType === 'total') remaining = money(Math.max(0,(CFG.giftThresholdCents||0) - cart.total_price), cart.currency);
      else remaining = Math.max(0,(CFG.giftThresholdCount||0) - cart.item_count) + '';
      var thresholdTxt = (CFG.giftThresholdType==='total') ? money(CFG.giftThresholdCents,cart.currency) : (CFG.giftThresholdCount+'');
      els.giftInner.innerHTML = '<p class="cd-gift__msg">'+escapeHtml(fill(CFG.giftMessage,{remaining:remaining,threshold:thresholdTxt}))+'</p>';
    }
  }

  function renderTotals(cart, b) {
    var currency = cart.currency, count = cart.item_count;
    var g = findGiftLine(cart);
    var giftOrig = g ? g.original_line_price : 0;
    var giftFinal = g ? g.final_line_price : 0;
    /* Real numbers from Shopify: automatic discounts and discount codes are
       already applied in cart.js. The gift is displayed as free, so both its
       original price and whatever it still costs are removed from display. */
    var origSubtotal = Math.max(0, cart.original_total_price - giftOrig);
    var realTotal = Math.max(0, cart.total_price - giftFinal);
    var realDiscount = Math.max(0, origSubtotal - realTotal);
    /* Fall back to the display-only estimate ONLY when Shopify reports no
       real discount (i.e. the backing automatic discount doesn't exist). */
    var estimate = (!realDiscount && b.unlocked && CFG.bundleShowEstimate && b.discount > 0) ? b.discount : 0;
    var discount = realDiscount || estimate;
    var showDisc = discount > 0;
    var pct = CFG.bundlePercent || 0;

    els.subtotal.textContent = money(origSubtotal, currency);
    if (els.shipping) {
      els.shipping.textContent = CFG.freeShippingText || 'Free';
      /* only give it the FREE badge treatment in markets that really are free */
      els.shipping.classList.toggle('is-plain', CFG.shippingIsFree === false);
    }
    /* optional extra shipping line (e.g. NZ free express over a threshold) */
    if (els.shipNote) {
      var noteTxt = '';
      if (CFG.shipNote) {
        var noteMin = CFG.shipNoteMinCents || 0;
        var payable = Math.max(0, origSubtotal - discount);
        if (!noteMin || payable >= noteMin) noteTxt = CFG.shipNote;
        else if (CFG.shipNoteBelow) noteTxt = fill(CFG.shipNoteBelow, { remaining: money(noteMin - payable, currency) });
      }
      els.shipNote.textContent = noteTxt;
      els.shipNote.hidden = !noteTxt;
    }
    /* tax / duty reassurance (market-specific; wording lives in theme settings).
       The message switches to a duty warning when goods exceed the duty-free
       ceiling, so we never promise "nothing to pay on delivery" on a cart where
       that would not be true. */
    if (els.taxNote) {
      var taxTxt = '', taxWarn = false;
      if (CFG.taxNote) {
        var goodsCents = Math.max(0, origSubtotal - discount);
        var taxMax = CFG.taxNoteMaxCents || 0;
        if (taxMax && goodsCents > taxMax && CFG.taxNoteOver) { taxTxt = fill(CFG.taxNoteOver, { max: money(taxMax, currency) }); taxWarn = true; }
        else taxTxt = CFG.taxNote;
      }
      els.taxNote.textContent = taxTxt;
      els.taxNote.hidden = !taxTxt;
      els.taxNote.classList.toggle('is-warn', taxWarn);
    }

    els.subtotal.classList.toggle('is-struck', showDisc);
    els.discountRow.hidden = !showDisc;
    els.totalRow.hidden = !showDisc;
    if (showDisc) {
      els.discountLabel.textContent = b.unlocked
        ? fill(CFG.discountLabel, { percent: pct, amount: money(CFG.bundleAmountCents, currency) })
        : (CFG.codeDiscountLabel || 'Discount');
      els.discountValue.textContent = '-' + money(discount, currency);
      els.totalLabel.textContent = CFG.totalLabel || 'Total';
      els.total.textContent = money(origSubtotal - discount, currency);
    }
    if (els.badge) {
      els.badge.hidden = !b.unlocked;
      if (b.unlocked) {
        els.badge.textContent = (CFG.bundleType==='price') ? 'BUNDLE'
          : (CFG.bundleType==='amount') ? (money(b.discount, currency) + ' OFF')
          : (pct + '% OFF');
      }
    }

    if (els.payment && CFG.showPayment) {
      var base = origSubtotal - discount;
      var n = CFG.paymentInstallments || 4;
      els.payment.innerHTML = fill(escapeHtml(CFG.paymentText), { installments:n, payment:'<b>'+money(Math.round(base/n),currency)+'</b>' });
    }
    if (els.checkout) els.checkout.classList.toggle('is-disabled', count === 0);
  }

  function renderUpsells(cart) {
    if (!CFG.hideUpsellInCart || !els.upsellCards.length) return;
    var ids = cart.items.map(function(i){ return String(i.product_id); });
    els.upsellCards.forEach(function(card){ card.hidden = ids.indexOf(card.getAttribute('data-product-id')) !== -1; });
  }

  function updateSiteCart(cart) {
    var count = cart.item_count;
    document.querySelectorAll('.cart-count-bubble span, #cart-icon-bubble [data-cart-count], [data-cart-count], [data-header-cart-count]').forEach(function(el){
      if (drawer.contains(el)) return;
      if (el.hasAttribute('data-header-cart-count')) { el.textContent='('+count+')'; el.setAttribute('data-header-cart-count',count); }
      else el.textContent = count;
    });
    document.querySelectorAll('[data-header-cart-price]').forEach(function(el){ if(!drawer.contains(el)){ el.textContent=money(cart.total_price,cart.currency); el.setAttribute('data-header-cart-price',cart.total_price);} });
    document.querySelectorAll('[data-header-cart-full]').forEach(function(el){ el.setAttribute('data-header-cart-full', count>0); });
    selfDispatch = true;
    try { document.dispatchEvent(new CustomEvent('cart:updated', { detail:{ count:count } })); } finally { selfDispatch = false; }
  }

  /* data actions */
  function refresh(quiet) {
    if (!quiet) drawer.classList.add('is-loading');
    return getCart().then(maybeSyncGift).then(function(cart){
      render(cart);
      drawer.classList.remove('is-loading');
      return cart;
    }).catch(function(){ drawer.classList.remove('is-loading'); });
  }
  function changeQty(key, qty, lineEl) {
    /* optimistic: update the line immediately, reconcile on response */
    if (lineEl) {
      var v = lineEl.querySelector('.cd-qty__value');
      if (v && qty > 0) v.textContent = qty;
      if (qty === 0) lineEl.style.opacity = '0.35';
    }
    return postJSON('/cart/change.js', { id:key, quantity:qty })
      .then(maybeSyncGift).then(render)
      .catch(function(){ refresh(true); });
  }
  function quickAdd(variantId, btn) {
    if (btn) btn.classList.add('is-loading');
    drawer.classList.add('is-booting');
    return postJSON('/cart/add.js', { items:[{ id:variantId, quantity:1 }] })
      .then(function(){ if(btn) btn.classList.remove('is-loading'); openDrawer(); })
      .catch(function(){ if(btn) btn.classList.remove('is-loading'); drawer.classList.remove('is-booting'); });
  }
  function claimGift(btn) {
    if (btn) btn.classList.add('is-loading');
    var sel = drawer.querySelector('[data-cd-claim-variant]');
    var vid = (sel && sel.value) ? Number(sel.value) : CFG.giftVariantId;
    return postJSON('/cart/add.js', { items:[{ id:vid, quantity:1, properties:{ _gift:'true' } }] })
      .then(function(){ return refresh(true); })
      .catch(function(){ if(btn) btn.classList.remove('is-loading'); });
  }
  function swapGift(oldVariantId, newVariantId) {
    if (giftBusy) return;
    giftBusy = true;
    /* single round trip: update.js swaps both lines and returns the cart.
       The new line has no _gift property, but isGift() also matches by
       product_id, so it still renders as the gift. */
    var updates = {}; updates[oldVariantId] = 0; updates[newVariantId] = 1;
    postJSON('/cart/update.js', { updates: updates })
      .then(function(cart){ giftBusy=false; render(cart); })
      .catch(function(){ giftBusy=false; refresh(true); });
  }

  /* events inside the drawer */
  drawer.addEventListener('click', function(e){
    var t = e.target;
    if (t.closest('[data-cd-close]')) { closeDrawer(); return; }
    var vopt = t.closest('.cd-vsel__opt');
    if (vopt) {
      if (vopt.disabled || vopt.classList.contains('is-selected')) { closeVsels(); return; }
      var vwrap = vopt.closest('.cd-vsel');
      var vline = vopt.closest('.cd-item');
      closeVsels();
      var vkey = vline && vline.getAttribute('data-key');
      var vitem = ((lastCart && lastCart.items) || []).filter(function(i){ return i.key === vkey; })[0];
      if (vitem && vwrap) {
        if (vwrap.hasAttribute('data-cd-vsel-gift')) swapGift(vitem.variant_id, vopt.getAttribute('data-value'));
        else swapLine(vitem, Number(vopt.getAttribute('data-value')));
      }
      return;
    }
    var vbtn = t.closest('[data-cd-vsel-btn]');
    if (vbtn) { toggleVsel(vbtn); return; }
    closeVsels();
    var checkout = t.closest('[data-cd-checkout]');
    if (checkout) { if (checkout.classList.contains('is-disabled')) e.preventDefault(); return; }
    var claim = t.closest('[data-cd-claim-gift]'); if (claim) { e.preventDefault(); claimGift(claim); return; }
    var rm = t.closest('[data-cd-remove-code]'); if (rm) { e.preventDefault(); removeCode(rm.getAttribute('data-code')); return; }
    var dtoggle = t.closest('[data-cd-discount-toggle]');
    if (dtoggle) {
      var form = els.discountForm;
      if (form) {
        var opening = form.hidden;
        form.hidden = !opening;
        dtoggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
        dtoggle.classList.toggle('is-open', opening);
        if (opening && els.discountInput) els.discountInput.focus();
        if (!opening && els.discountErrorEl) els.discountErrorEl.hidden = true;
      }
      return;
    }
    var quick = t.closest('[data-cd-quickadd]');
    if (quick) {
      e.preventDefault();
      var card = quick.closest('[data-cd-upsell-card]');
      var select = card ? card.querySelector('[data-cd-variant-select]') : null;
      var variantId = (select && select.value) ? select.value : quick.getAttribute('data-variant-id');
      quickAdd(variantId, quick); return;
    }
    var line = t.closest('.cd-item'); if (!line) return;
    var key = line.getAttribute('data-key');
    var qtyEl = line.querySelector('.cd-qty__value');
    var qty = qtyEl ? (parseInt(qtyEl.textContent,10)||1) : 1;
    if (t.closest('[data-cd-plus]')) changeQty(key, qty+1, line);
    else if (t.closest('[data-cd-minus]')) changeQty(key, qty-1, line);
    else if (t.closest('[data-cd-remove]')) changeQty(key, 0, line);
  });
  /* discount code form */
  if (els.discountForm) {
    els.discountForm.addEventListener('submit', function(e){ e.preventDefault(); e.stopPropagation(); applyCode(); });
  }
  /* variant swaps: gift colour + line size selects */
  drawer.addEventListener('change', function(e){
    var t = e.target;
    if (!t.closest) return;
    var line = t.closest('.cd-item');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var item = ((lastCart && lastCart.items) || []).filter(function(i){ return i.key === key; })[0];
    if (!item) return;
    var giftSel = t.closest('[data-cd-gift-variant]');
    if (giftSel) { swapGift(item.variant_id, giftSel.value); return; }
    var lineSel = t.closest('[data-cd-line-variant]');
    if (lineSel) { swapLine(item, Number(lineSel.value)); }
  });
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('click', function(e){
    if (!(e.target.closest && e.target.closest('.cd-vsel')) && !drawer.contains(e.target)) closeVsels();
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape' || !drawer.classList.contains('is-open')) return;
    if (drawer.querySelector('.cd-vsel__menu:not([hidden])')) { closeVsels(); return; }
    closeDrawer();
  });

  /* hook the site's cart trigger(s) */
  var TRIGGER_SELECTOR = window.CART_DRAWER_TRIGGER || [
    'a[href="/cart"]','a[href$="/cart"]','a[href*="/cart?"]',
    '[data-cart-drawer-toggle]','[data-drawer-toggle="drawer-cart"]',
    '.cart-link','#cart-icon-bubble','.site-header__cart','.header__icon--cart','.navlink--cart',
    /* Horizon */
    '[data-testid="cart-drawer-trigger"]','cart-drawer-component .header-actions__cart-icon'
  ].join(',');
  function neutralizeThemeCart() {
    document.querySelectorAll('[data-drawer-toggle="drawer-cart"]').forEach(function(el){ el.removeAttribute('data-drawer-toggle'); });
    /* Horizon: stop the native drawer auto-opening after add-to-cart */
    document.querySelectorAll('cart-drawer-component[auto-open]').forEach(function(el){ el.removeAttribute('auto-open'); });
  }
  neutralizeThemeCart();
  document.addEventListener('shopify:section:load', neutralizeThemeCart);
  window.addEventListener('click', function(e){
    var trigger = e.target.closest && e.target.closest(TRIGGER_SELECTOR);
    if (!trigger || drawer.contains(trigger)) return;
    e.preventDefault(); e.stopPropagation(); openDrawer();
  }, true);

  /* take over add-to-cart forms so adds open the drawer */
  if (CFG.openOnAdd) {
    window.addEventListener('submit', function(e){
      var form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var btn = form.querySelector('[type="submit"], button:not([type])');
      if (btn) btn.classList.add('is-loading');
      drawer.classList.add('is-booting');
      fetch(route('/cart/add.js'), { method:'POST', headers:{'Accept':'application/json'}, body:new FormData(form) })
        .then(function(r){return r.json();})
        .then(function(){ if(btn) btn.classList.remove('is-loading'); openDrawer(); })
        .catch(function(){ if(btn) btn.classList.remove('is-loading'); drawer.classList.remove('is-booting'); });
    }, true);
  }

  window.DrawerCart = {
    open: openDrawer, close: closeDrawer, refresh: refresh,
    add: function(variantId, qty){ return postJSON('/cart/add.js', { items:[{ id:variantId, quantity:qty||1 }] }).then(function(){ return refresh(); }).then(openDrawer); }
  };

  /* Bridge for external scripts (e.g. the SFT product section's
     openCartDrawer helper) that grab #CartDrawer and call .open()/.show()
     or dispatch cart events instead of using window.DrawerCart. */
  drawer.open = openDrawer;
  drawer.show = openDrawer;
  ['cart:refresh','cart:updated'].forEach(function(evt){
    document.addEventListener(evt, function(){ if (!selfDispatch) refresh(true); });
  });
  ['cart:open','theme:cart:open'].forEach(function(evt){
    document.addEventListener(evt, function(){ if (!selfDispatch && !drawer.classList.contains('is-open')) openDrawer(); });
  });

  function prime(){ getCart().then(maybeSyncGift).then(function(cart){ render(cart); }).catch(function(){}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prime); else prime();
})();
